import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Table, Button, Badge } from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Pagination from '../Components/pagination';
import _ from 'lodash';

import {
  getLiveTransporters,
  deleteLiveTransporter
} from "../../services/api/api-service";

const LiveVehiclesLists = () => {

  const [list, setList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(20);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    getLiveTransporters().then(data => {
      if (!_.isEmpty(data)) {
        setList(data);
      }
    });
  };

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are you sure to delete?");
    if (!confirm) return;

    try {
      await deleteLiveTransporter(id);

      // ✅ refresh list
      fetchData();

      alert("Deleted successfully ✅");

    } catch (err) {
      console.log(err);
      alert("Delete failed ❌");
    }
  };

  // ✅ PAGINATION
  const indexOfLast = currentPage * postsPerPage;
  const indexOfFirst = indexOfLast - postsPerPage;
  const currentPosts = list.slice(indexOfFirst, indexOfLast);

  const paginate = pageNumber => setCurrentPage(pageNumber);

  return (
    <div className="page-content">
      <Container fluid>

        <Breadcrumbs title="Admin" breadcrumbItem="Live Vehicles" />

        <Row>
          <Col lg="12">
            <div className="table-responsive">
              <Table className="table-nowrap table-centered table-borderless">

                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Contact</th>
                    <th>Business</th>
                    <th>Cuurent Location</th>
                    <th>Destination Location</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {currentPosts.map(item => {

                    const isActive = item.isActive;

                    return (
                      <tr key={item.id || item._id}>

                        <td>{item.contactName}</td>

                        <td>{item.contactNumber}</td>

                        <td>{item.businessName}</td>

                        <td>{item.currentLocation}</td>
                                            
                        <td>{item.destinationLocation}</td>

                        <td>
                          {item.createdAt
                            ? new Date(item.createdAt).toLocaleString()
                            : '-'}
                        </td>

                        <td>
                          <Badge
                            color={isActive ? "success" : "secondary"}
                            pill
                          >
                            {isActive ? "Active" : "Expired"}
                          </Badge>
                        </td>

                        <td>

                          {/* ❌ DELETE BUTTON */}
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => handleDelete(item.id || item._id)}
                          >
                            Delete
                          </Button>

                        </td>

                      </tr>
                    );
                  })}
                </tbody>

              </Table>
            </div>
          </Col>
        </Row>

        {/* ✅ PAGINATION */}
        <Row>
          <Col lg="12">
            <Pagination
              postsPerPage={postsPerPage}
              totalPosts={list.length}
              paginate={paginate}
            />
          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default LiveVehiclesLists;
